import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";

import {SwalAlertClass} from "core/swalClass";
import ModalFirmwareTable from "./ModalFirmwareTable";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import LoaderSpinner from "context/LoaderSpinner";
import axiApi from "ApiCaller";
import itemsModel from "core/itemsModel";

const FirmwareModel = {
    id: "",
    name: "",
    device_model: "",
    version: "",
    size: "",
    create_at: "",
};

const ModalFirmwareSelect = ({show, setShow, items, model, setItemsParent}) => {
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const navigate = useNavigate();
    const [item, setItem] = useState({...FirmwareModel});
    const [itemsShown, setItemsShown] = useState([]);
    const firmwares = useRef(new itemsModel());
    const [isLoading, setIsLoading] = useState(false);
    const filters = useRef({searcher: ""});

    useEffect(() => {
        setIsLoading(true);
        firmwares.current.reset();
        setItemsShown([]);
        axiApi
            .post("/api/devices/advanced/blobs/", {type: model})
            .then((resp) => {
                firmwares.current.all = [...resp.data.items];
                firmwares.current.showed = [...resp.data.items];
                setItemsShown([...firmwares.current.showed]);
            })
            .catch((error) => {
                console.error("Error fetching firmwares:", error);
            })
            .finally(() => setIsLoading(false));
    }, []);

    const handleClose = () => {
        setItem({...FirmwareModel});
        setShow(false);
    };

    const handleAccept = () => {
        if (!item.id) {
            Alert.warning("Seleccione un firmware", "No se puede aceptar sin seleccionar un firmware");
            return;
        }
        let dataSend = {
            ids: items.current.getChosenUuids(),
            model: item.device_model,
            file: item.name,
            version: item.version,
        };
        axiApi.post("/api/devices/advanced/update/", dataSend).then((resp) => {
            if (resp.data.status) {
                Alert.success("Actualización", "Se ha enviado la actualización a los dispositivos seleccionados").then((r) => {
                    navigate(0);
                });
            } else {
                Alert.error("Error en el servidor", "No se ha podido enviar la actualizacion");
            }
        });
        setShow(false);
    };

    const filterItems = () => {
        let _items = [...firmwares.current.all];

        if (filters.current.searcher) {
            _items = _items.filter((firmware) => {
                const words = toLowCaseCleanSpaces((firmware.name || "") + " " + (firmware.version || ""));
                return words.includes(filters.current.searcher);
            });
        }

        firmwares.current.showed = _items;
        setItemsShown([...firmwares.current.showed]);
    };

    const handleSearch = (e) => {
        filters.current.searcher = toLowCaseCleanSpaces(e.target.value);
        filterItems();
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} scrollable={true} size="lg" aria-modal>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="cloud-arrow-up" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline me-4">Firmware - {model}</Modal.Title>
                        <form className="d-inline-flex ms-2" role="search" onSubmit={handleFormSubmit}>
                            <input
                                className="form-control border-end-0 rounded-0"
                                type="search"
                                placeholder="Nombre, Versión"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0" id="basic-addon1">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3 h5 text-center">
                        Se aplicara el firmaware seleccionado a {items.current.chosen.length} dispositivos.
                    </div>
                    <LoaderSpinner isLoading={isLoading}>
                        <ModalFirmwareTable itemsShown={itemsShown} setItem={setItem} />
                    </LoaderSpinner>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Enviar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalFirmwareSelect;
